export const API = {
  url: 'http://localhost:8000'
};



// WEBPACK FOOTER //
// ./src/api.js